import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHousekeeping = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#06A3A3",
			d: "M29.09 1.085a4.445 4.445 0 0 1 5.82 0L37.127 3a4.45 4.45 0 0 0 3.912.97l2.848-.66a4.46 4.46 0 0 1 5.154 2.722l1.078 2.734a4.48 4.48 0 0 0 3.016 2.689l2.827.747a4.49 4.49 0 0 1 3.306 4.82l-.308 2.925a4.51 4.51 0 0 0 1.429 3.791l2.157 1.984a4.515 4.515 0 0 1 .702 5.814l-1.623 2.446a4.52 4.52 0 0 0-.486 4.025l.994 2.766a4.51 4.51 0 0 1-2.063 5.476l-2.567 1.407a4.5 4.5 0 0 0-2.289 3.336l-.397 2.914c-.3 2.2-2.15 3.85-4.356 3.884l-2.922.045a4.46 4.46 0 0 0-3.568 1.884l-1.697 2.395a4.45 4.45 0 0 1-5.65 1.401l-2.61-1.326a4.44 4.44 0 0 0-4.029 0l-2.608 1.326a4.45 4.45 0 0 1-5.65-1.401l-1.698-2.395a4.46 4.46 0 0 0-3.567-1.884l-2.923-.045a4.476 4.476 0 0 1-4.356-3.884l-.397-2.914a4.5 4.5 0 0 0-2.289-3.337L3.93 46.25a4.51 4.51 0 0 1-2.063-5.476l.994-2.766a4.52 4.52 0 0 0-.486-4.025L.752 31.537a4.515 4.515 0 0 1 .702-5.814L3.61 23.74a4.51 4.51 0 0 0 1.429-3.79l-.308-2.926a4.49 4.49 0 0 1 3.306-4.82l2.827-.747a4.48 4.48 0 0 0 3.016-2.689l1.078-2.734a4.46 4.46 0 0 1 5.154-2.721l2.848.66a4.45 4.45 0 0 0 3.912-.97z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 24,
			fill: "#1CC6C6"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 20,
			fill: "#027E7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9BFAFA",
			fillRule: "evenodd",
			d: "M32 20a4 4 0 0 0-4 4v8.723l-5.858 9.763A1 1 0 0 0 23 44h18a1 1 0 0 0 .858-1.514L36 32.723V24a4 4 0 0 0-4-4m2 8v-4a2 2 0 0 0-4 0v4zm-4 2h4v2h-4zm5 12v-3a1 1 0 1 0-2 0v3h-2v-3a1 1 0 1 0-2 0v3h-4.234l4.8-8h4.868l4.8 8z",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgHousekeeping);
export default ForwardRef;
